// @ts-nocheck
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  autoComplete: {
    '& .MuiOutlinedInput-root': {
      padding: '0px !important',
    },
    '&  .MuiAutocomplete-tag': {
      margin: '8px 5px 8px !important',
    },
  },
  cautionBox: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid',
    borderRadius: '4px',
    margin: '5px 0px 0px 0px',
    backgroundColor: '#F44336',
    borderColor: '#F44336',
  },
  cautionText: {
    padding: 5,
    fontWeight: 400,
    color: 'white',
  },
}));
